import styles from './GoalBadge.module.scss';
import { getTranslation } from '../../../../../../../utils/translation';

const GoalBadge = () => {
    return <span className={styles.goalBadge}>{getTranslation('common.goal')}</span>;
};

export default GoalBadge;
